export default __webpack_public_path__ + "../staticImages/benefit-nature.svg";